import { call, put, takeEvery } from "redux-saga/effects";

import * as apis from "../../network/apis/userTags";
import { showErrorMsg } from "../../utils/Helpers";
import * as actions from "./actions";
import * as types from "./types";

const normalizeIds = (ids = []) =>
  ids.map((id) => {
    const numberId = Number(id);
    return Number.isFinite(numberId) ? numberId : id;
  });

function* assignUserTagSaga({ payload }) {
  try {
    const response = yield call(apis.bulkAssignTag, payload.portalVariant, {
      user_ids: normalizeIds(payload.userIds),
      tag_id: payload.tagId,
    });
    payload.onSuccess?.(response);
  } catch (error) {
    yield call(showErrorMsg, error.response?.data?.message);
    payload.onError?.(error);
  } finally {
    yield put(actions.userTagResponse());
  }
}

function* removeUserTagSaga({ payload }) {
  try {
    const response = yield call(apis.bulkRemoveTag, payload.portalVariant, {
      user_ids: normalizeIds(payload.userIds),
    });
    payload.onSuccess?.(response);
  } catch (error) {
    yield call(showErrorMsg, error.response?.data?.message);
    payload.onError?.(error);
  } finally {
    yield put(actions.userTagResponse());
  }
}

export default function* userTagsSagas() {
  yield takeEvery(types.ASSIGN_USER_TAG_REQUEST, assignUserTagSaga);
  yield takeEvery(types.REMOVE_USER_TAG_REQUEST, removeUserTagSaga);
}
